import { i18n } from 'i18n';

export interface QAQCTablePageParams {
  projectId: string;
}

export const ROUTE_PARAM_IDENTIFIER = ':projectId';

export const ROUTE_PATH = `/projects/${ROUTE_PARAM_IDENTIFIER}/qaqc/table`;
export const TITLE = i18n._('QAQC Table');
